import {BaseObject} from './BaseObject';

export class CustomerContactPerson extends BaseObject {
    id: number = 0;
    customerId: number;
    name = '';
    surname = '';
    email = '';
    phone = '';
    position = '';
    note = '';

    getFullName = (): string => {
        return [this.name, this.surname].join(' ');
    }
}



// WEBPACK FOOTER //
// /app/src/model/Entities/CustomerContactPerson.ts